import baseUrl from "./baseUrl";
let weatherKey = "3cf619f4253b4abc7fa406ee7df172d6";
let ipKey = "at_Xm0eZXyJWb9DtGX9iSlE9LUp3vZ7n";

let weatherBaseUrl = "https://api.openweathermap.org/data/2.5";
let ipUrl = "https://geo.ipify.org/api/v1";
let weatherIconUrl = "https://openweathermap.org/img/wn";

export const verifyLogin = baseUrl + "users/verifylogin";
export const weatherApi = (city) => `${weatherBaseUrl}/weather?q=${city}&appid=${weatherKey}`;
export const weatherOneCallApi = (lat, lng) =>
  `${weatherBaseUrl}/onecall?lat=${lat}&lon=${lng}&exclude=hourly,daily,minutely,alerts&appid=${weatherKey}`;

export const ipResolve = `${ipUrl}?apiKey=${ipKey}`;
export const weatherIcon = (id) => `${weatherIconUrl}/${id}@2x.png`;
export const suspended = baseUrl + "users/suspended";
export const enable = baseUrl + "users/enable";
export const inviteUsers = baseUrl + "users/invite";
export const searchResults = baseUrl + "notarize/search";
